export default theme => ({
  close: {
    width: theme.spacing(2.5),
    height: theme.spacing(2.5)
  }
});
